// src/context/SwalContext.js
import { createContext, useContext } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const ReactSwal = withReactContent(Swal);

const SwalContext = createContext();

export const useSwal = () => {
  return useContext(SwalContext);
};

export const SwalProvider = ({ children }) => {
 const alert = (type, message, title = '') => {
  let options = {
    title: title || (type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Warning'),
    text: message,
    icon: type,
    confirmButtonText: 'OK',
  };

  if (type === 'success') {
    options = {
      ...options,
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
    };
  }

  if (type === 'question') {
    options = {
      ...options,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    };
  }

  return ReactSwal.fire(options);
};

  return (
    <SwalContext.Provider value={alert}>
      {children}
    </SwalContext.Provider>
  );
};
